import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { Injectable } from '@angular/core';
import {
  GetAllFormulationStock, GetAllFormulationStockSuccess, GetAllFormulations, GetAllFormulationsByCompanyId, EFormulationActions, GetAllFormulationsSuccess, GetAllFormulationsByCompanyIdSuccess, GetAllFormulationsError, GetAllFormulationsByCompanyIdError, AddFormulation, GetAddFormulationSuccess, GetAddFormulationError, EditFormulation, GetEditFormulationSuccess,
  GetEditFormulationError, GetInActiveStatus, GetFormulationNumber, GetFormulaById, GetActiveFormulations, GetMlcsByFormulaId, GetActiveStatus, GetImportProduct, GetImportProductSuccess, GetImportProductError, GetParentFormulas
} from '../actions/formulation.action';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { FormulationService } from '../../Services/Formulation/formulation.service';


@Injectable()
export class FormulationEffects {


    getAllFormulationStock$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllFormulationStock>(EFormulationActions.GetAllFormulationStock),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.getAllFormulationStock(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Set All Formulation Stock Success', payload: result })),
                catchError((err) => of({ type: 'Set All Formulation Stock Error', payload: err, from: 'getFormulationStock' }))
            )
        )
    ));


    getAllFormulations$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllFormulations>(EFormulationActions.GetAllFormulations),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.getAllFormulations(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Set All Formulation Success', payload: result })),
                catchError((err) => of({ type: 'Set All Formulation Error', payload: err, from: 'getFormulation' }))
            )
        )

    ));


    getAllFormulationsByCompanyId$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllFormulations>(EFormulationActions.GetAllFormulationsByCompanyId),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.getAllFormulationsByCompanyId(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Set All Formulation By Company ID Success', payload: result })),
                catchError((err) => of({ type: 'Set All Formulation By Company ID Error', payload: err, from: 'getFormulationByCompanyId' }))
            )
        )

    ));


    getaddformulation$ = createEffect(() => this.actions$.pipe(
        ofType<AddFormulation>(EFormulationActions.AddFormulation),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.formulationService.addFormulation(payload).pipe(
                map((result: any) => {
                    return new GetAddFormulationSuccess(result);
                }),
                catchError((err) => of(new GetAddFormulationError(err)))
            );
        })));

    geteditformulation$ = createEffect(() => this.actions$.pipe(
        ofType<EditFormulation>(EFormulationActions.EditFormulation),
        map(action => action),
        switchMap((action) => {
            return this.formulationService.editFormulation(action.payload, action.param).pipe(
                map((result: any) => {
                    return new GetEditFormulationSuccess(result);
                }),
                catchError((err) => of(new GetEditFormulationError(err)))
            );
        })));

    getFormulationNum$ = createEffect(() => this.actions$.pipe(
        ofType<GetFormulationNumber>(EFormulationActions.GetFormulationNumber),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.beforeNewCreation(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Set Formulation Number Success', payload: result, from: 'getFormulationNum' })),
                catchError((err) => of({ type: '[Formulation] Set Formulation Number Error', payload: err, from: 'getFormulationNum' }))
            )
        )

    ));

    getInActiveStatus$ = createEffect(() => this.actions$.pipe(
        ofType<GetInActiveStatus>(EFormulationActions.GetInActiveStatus),
        map(action => action),
        mergeMap((action) => this.formulationService.inActive(action.payload, action.param)
            .pipe(map((result: any) => ({ type: '[Formulation]  InActive Status Success', payload: result })),
                catchError((err) => of({ type: '[Formulation]  InActive Status Error', payload: err }))
            )
        )
    ));

    getActiveStatus$ = createEffect(() => this.actions$.pipe(
        ofType<GetActiveStatus>(EFormulationActions.GetActiveStatus),
        map(action => action),
        mergeMap((action) => this.formulationService.active(action.payload, action.param)
            .pipe(map((result: any) => ({ type: '[Formulation]  Active Status Success', payload: result })),
                catchError((err) => of({ type: '[Formulation]  Active Status Error', payload: err }))
            )
        )
    ));

    getFormulaById$ = createEffect(() => this.actions$.pipe(
        ofType<GetFormulaById>(EFormulationActions.GetFormulaById),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.getFormulaById(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Set Formula Details By Id Success', payload: result })),
                catchError((err) => of({ type: '[Formulation] Set Formula Details By Id Error', payload: err }))
            )
        )
    ));

    getActiveFormula$ = createEffect(() => this.actions$.pipe(
        ofType<GetActiveFormulations>(EFormulationActions.GetActiveFormulations),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.getActiveFormulation(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Set Active Formulations Success', payload: result })),
                catchError((err) => of({ type: '[Formulation] Set Active Formulation Error', payload: err }))
            )
        )
    ));

    getMlcsByFormulaId$ = createEffect(() => this.actions$.pipe(
        ofType<GetMlcsByFormulaId>(EFormulationActions.GetMlcsByFormulaId),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.getMlcsByFormulaId(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Get Mlc By FormulaId Success', payload: result })),
                catchError((err) => of({ type: '[Formulation] Get Mlc By FormulaId Error', payload: err }))
            )
        )
    ));

    getImportProduct$ = createEffect(() => this.actions$.pipe(
        ofType<GetImportProduct>(EFormulationActions.GetImportProduct),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.getImportProduct(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Get Import Product Success', payload: result })),
                catchError((err) => of({ type: '[Formulation] Get Import Product Error', payload: err }))
            )
        )
    ));

    getParentFormulas$ = createEffect(() => this.actions$.pipe(
        ofType<GetParentFormulas>(EFormulationActions.GetParentFormulas),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.getParentFormulas(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Get Parent Formulas Success', payload: result })),
                catchError((err) => of({ type: '[Formulation] Get Parent Formulas Error', payload: err }))
            )
        )
    ));

    getSubEditFormula$ = createEffect(() => this.actions$.pipe(
        ofType<GetParentFormulas>(EFormulationActions.SubEditFormula),
        map(action => action.payload),
        mergeMap((payload: any) => this.formulationService.getSubEditFormula(payload)
            .pipe(map((result: any) => ({ type: '[Formulation] Sub Edit Formula Success', payload: result })),
                catchError((err) => of({ type: '[Formulation] Sub Edit Formula Error', payload: err }))
            )
        )
    ));
    constructor(private actions$: Actions,
        private store: Store<IAppState>,
        private formulationService: FormulationService
    ) { }
}
